import { useGetListCompanyByRso } from "@/api/services/main/company";
import { FormField } from "@/components/elements/FormField";
import { InnerBox } from "@/components/elements/InnerBox";
import { Input } from "@/components/elements/Input";
import { Select } from "@/components/elements/Select";
import { useGetLearnerSchema } from "@/features/learner/hook/useGetLearnerSchema";
import { Grid } from "@mui/material";
import { FC, useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { TLearnerForm } from "@/features/learner/types/learnerForm";
import { LearnerFormTitle } from "@/features/learner/components/learner-form/LearnerFormTitle";
import { useGetProvinceAndMunicipalityList } from "@/hooks/useGetProvinceAndMunicipalityList";
import { useGetNationalityList } from "@/api/services/global/master";
import { useEnum } from "@/api/services/global/enum";
import { useParams } from "react-router-dom";

export const LearnerBasicInfoForm: FC = () => {
  const { control } = useFormContext<TLearnerForm>();
  const { isRsoUser } = useGetLearnerSchema();
  const { nationalityOptions, isLoading: isLoadingNationality } = useGetNationalityList();
  const { data: genderOptions } = useEnum("EGender");
  const { isLoading: isLoadingProvinceAndMunicipalityList, provinceOptions, getMunicipalityOptionsByProvince } = useGetProvinceAndMunicipalityList();
  const { data: companyListData, isLoading: isLoadingCompanyList } = useGetListCompanyByRso(isRsoUser);
  const rsoCompanyId = useWatch({ control, name: "rsoCompanyId" });
  const { learnerId } = useParams();

  const companyOptions = useMemo(() => {
    const companies = companyListData?.data ?? [];
    return companies
      .filter((c) => !c.isArchive || String(c.id) === String(rsoCompanyId))
      .map((c) => ({ label: c.companyName, value: c.id }));
  }, [companyListData, rsoCompanyId]);

  const prefectureWatchField = useWatch({ control, name: "prefecture" });

  return (
    <InnerBox title={<LearnerFormTitle text="基本情報" />} showDivider={false}>
      <Grid container rowSpacing={2} columnSpacing={3}>
        {isRsoUser && (
          <Grid item xs={12}>
            <FormField control={control} name="rsoCompanyId">
              <Select placeholder="選択してください" loading={isLoadingCompanyList} options={companyOptions} readonly={!!learnerId} />
            </FormField>
          </Grid>
        )}
        <Grid item xs={6}>
          <FormField control={control} name="fullName">
            <Input placeholder="入力してください" />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="nickName">
            <Input placeholder="入力してください" />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="nationalityId">
            <Select placeholder="選択してください" loading={isLoadingNationality} options={nationalityOptions} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="gender">
            <Select placeholder="選択してください" options={genderOptions} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="prefecture">
            <Select placeholder="選択してください" loading={isLoadingProvinceAndMunicipalityList} options={provinceOptions} />
          </FormField>
        </Grid>
        <Grid item xs={6}>
          <FormField control={control} name="city">
            <Select
              options={prefectureWatchField ? getMunicipalityOptionsByProvince(prefectureWatchField) : []}
              loading={isLoadingProvinceAndMunicipalityList}
              disabled={!prefectureWatchField}
            />
          </FormField>
        </Grid>
      </Grid>
    </InnerBox>
  );
};
